// Language versions for code execution
export const LANGUAGE_VERSIONS = {
  javascript: '18.15.0',
  python: '3.10.0',
  java: '15.0.2',
  c: 'gcc-11.2.0',
  cpp: 'g++-11.2.0',
  csharp: '6.12.0',
  ruby: '3.1.0',
  swift: '5.7',
  rust: '1.58.1',
};

// export const CODE_SNIPPETS: Record<
//   'javascript' | 'typescript' | 'python' | 'java' | 'csharp' | 'php',
//   string
// > = {
//   javascript: 'console.log("Hello, JavaScript!");',
//   typescript: 'console.log("Hello, TypeScript!");',
//   python: 'print("Hello, Python!")',
//   java: 'public class HelloWorld { public static void main(String[] args) { System.out.println("Hello, Java!"); } }',
//   csharp:
//     'using System; class Program { static void Main() { Console.WriteLine("Hello, C#!"); } }',
//   php: '<?php echo "Hello, PHP!"; ?>',
// };

export const CODE_SNIPPETS: Record<
  'javascript' | 'typescript' | 'python' | 'java' | 'csharp' | 'php' | 'r',
  string
> = {
  javascript: '',
  typescript: '',
  python: '',
  java: '',
  csharp:
    'using System; class Program { static void Main() { Console.WriteLine("Hello, C#!"); } }',
  php: '<?php echo "Hello, PHP!"; ?>',
  r: '',
};
